import template from './stExtras.html';
import controller from './stExtras.controller';

let stExtrasComponent = {
    restrict: 'E',
    bindings: {
        data: '=',
        index: '='
    },
    template,
    controller,
    controllerAs: 'vm'
};

export default stExtrasComponent;



// WEBPACK FOOTER //
// ./client/app/common/stExtras/stExtras.component.js